import { TokenSymbol } from "@gearbox-protocol/ui-kit";
import type { FC } from "react";
import { Fragment } from "react";

import type { Balance } from "./useTokenBalances";

export interface BalancesListProps {
  tokens?: Balance[];
  emptyMessage?: string;
}

const BalancesList: FC<BalancesListProps> = props => {
  const { tokens, emptyMessage } = props;

  if (tokens && tokens.length === 0) {
    return (
      <div className="text-sm text-muted-foreground">
        {emptyMessage ?? "No tokens with non-zero balance"}
      </div>
    );
  }

  return (
    <div className="grid grid-cols-[auto_1fr] gap-x-4 gap-y-1 items-center">
      {tokens?.map(([symbol, balance]) => (
        <Fragment key={symbol}>
          <TokenSymbol token={symbol} showSymbol size={18} />
          <span className="text-right tabular-nums">{balance}</span>
        </Fragment>
      ))}
    </div>
  );
};

export default BalancesList;
